import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCommentSmileRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M3.2 15.2q.1 4.1 2.6 7.2L3.4 27l-.2.6q.1 1.2 1.3 1.3l.5-.1 5.9-2.5q2.3 1 5.1 1c7 0 12.8-5.4 12.8-12s-5.7-12-12.8-12c-7 0-12.8 5.4-12.8 12m4.7 8.4q.7-1.5-.2-2.7a9 9 0 0 1-2.1-5.7c0-5.2 4.5-9.6 10.4-9.6s10.4 4.4 10.4 9.6-4.5 9.6-10.4 9.6q-2.3 0-4.2-.8-1-.5-1.9 0L7 25.2zm4.9-9.2a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2m6.4 0a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2m-8.5 3.1q-.7.8 0 1.7a7.2 7.2 0 0 0 10.7 0 1.2 1.2 0 0 0-1.8-1.6 5 5 0 0 1-7.2 0q-.8-.7-1.7-.1"
	})
});
export default SvgCommentSmileRegularIcon;
